const LINK_PREVIEW_TYPE = "wix-draft-plugin-link-preview";
export {
  LINK_PREVIEW_TYPE
};
//# sourceMappingURL=types.js.map
